/**
 * ================================================
 *
 * [page]
 *
 * ================================================
 */
var rTimer = false,
  isFirst = true;
/**
 ********************************************
 * load event
 ********************************************
 */
(function($) {
	$(function() {
		functions.init();
		/**
		 ********************************************
		 * resize event
		 ********************************************
		 */
		$(window).resize(function() {
			if (rTimer !== false) {
				clearTimeout(rTimer);
			}

			rTimer = setTimeout(function() {
				if ($.params.isChangeWWidth) {
					functions.adjust();
				}
				if ($.params.isChangeMode) {

				}
			}, 1000);
		});
		/**
		 ********************************************
		 * click event
		 ********************************************
		 */

	});
}(jQuery));
/**
 **********************************************************
 *
 * functions
 *
 **********************************************************
 */
var functions = {
	init: function() {
    $('#entryList.list2 .item').each(function() {
      $(this).magnificPopup({
    		delegate: 'a.popup',
    		type: 'image',
    		gallery: {
    			enabled: true,
    			navigateByImgClick: true,
    			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
    		}
    	});
    });
		setTimeout(function() {
			functions.adjust();
		}, 500);
	},
	adjust: function() {
		if (!$.params.isRespMode) {

		} else {
		}
	}
};
